// extracted by mini-css-extract-plugin
module.exports = {"fullWidthBannerSectionWrapper":"_1Ak1y","fullWidthBannerWrapper":"_3c3Pa"};